import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, DISCIPLINES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { Marquee } from "../components/shared/Marquee";

export default function Disciplines() {
  return (
    <>
      <PageHero
        eyebrow="The Martial Arts"
        title="Disciplines"
        intro="The founding martial arts of Kumite Games. Each discipline is delivered under the technical authority of its own participating organisation — its rules, its officials, its culture. More arts will join as the festival grows."
        image={IMAGES.karate}
        testId="disciplines-page-hero"
      />
      <Marquee items={DISCIPLINES.map((d) => d.name)} testId="disciplines-page-marquee" />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {DISCIPLINES.map((d, i) => (
            <Reveal key={d.slug} delay={(i % 3) * 0.1}>
              <Link
                to={`/disciplines/${d.slug}`}
                data-testid={`directory-card-${d.slug}`}
                className="group clip-frame relative block overflow-hidden border border-white/5 bg-ink-card transition-colors duration-300 hover:border-kred/40"
              >
                <div className="relative h-64 overflow-hidden sm:h-72">
                  <img
                    src={IMAGES[d.image]}
                    alt={d.name}
                    loading="lazy"
                    className="h-full w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-card via-ink-card/10 to-transparent" />
                  <span className="absolute left-5 top-5 border border-gold/30 bg-black/60 px-3 py-1 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-gold backdrop-blur-sm">
                    {d.family}
                  </span>
                </div>
                <div className="p-7">
                  <div className="flex items-start justify-between gap-3">
                    <h2 className="font-head text-xl font-bold uppercase tracking-wide text-bone transition-colors duration-300 group-hover:text-kred">
                      {d.name}
                    </h2>
                    <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-slate-500 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-kred" />
                  </div>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gold/80">
                    {d.origin} — {d.tag}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-slate-400">{d.blurb}</p>
                </div>
              </Link>
            </Reveal>
          ))}
          <Reveal delay={0.2} className="clip-frame grid min-h-64 place-items-center border border-dashed border-gold/25 bg-gold/[0.03] p-8 text-center">
            <div data-testid="more-disciplines-placeholder">
              <p className="font-display text-3xl uppercase tracking-wide text-gold/70">More to Come</p>
              <p className="mx-auto mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
                Additional martial arts will be welcomed as new organisations join Kumite Games.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
